import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a555aaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "col-12 member-h" }, "決済方法")
], -1))
const _hoisted_2 = ["onTouchstart", "onTouchend"]
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "col-3 text-right" }
const _hoisted_7 = {
  key: 0,
  class: "selected"
}
const _hoisted_8 = ["onTouchstart"]
const _hoisted_9 = {
  key: 0,
  class: "row add-card mt-4"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新しいクレジットカードを追加", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "row paypay mt-4" }
const _hoisted_13 = {
  key: 0,
  class: "selected"
}
const _hoisted_14 = { class: "row justify-content-center mt-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 text-center modal-header" }, " カード情報を削除しますか？ ", -1))
const _hoisted_16 = { class: "col-12 text-center mb-4 mt-4" }
const _hoisted_17 = { class: "col-6" }
const _hoisted_18 = { class: "col-3 text-right" }
const _hoisted_19 = { class: "col-12 text-center" }

import { inject, onMounted, reactive, ref, toRefs, watch, computed, ssrContextKey } from 'vue';
import { Member, Shop } from '@/models';
import { Auth, DataStore } from 'aws-amplify';
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router';
import { CardListDto } from '../../../../common/card.dto';
import Modal from '../../components/Modal.vue'

interface Props {
  member: Member;
  shop: Shop;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    member: null,
    shop: null
  },
  emits: ['stopLoading', 'startLoading'],
  setup(__props: any, { emit }) {

const props = __props as {
  member: Member;
  shop: Shop;
}



const { member, shop } = toRefs(props);



const route = useRoute();
const router = useRouter();

const api: any = inject('api');

const cardList = ref();
const selectedCardId = ref<string | undefined>('');

const cardsEl = ref();

const holdHandler = ref<any>();

const activeDeleteCard = ref();

const selectedDeleteCard = ref<CardListDto | null>(null);

const selectCard = async(card: CardListDto) => {
  selectedCardId.value = card.cardId;
}

const selectPaypay = async() => {
  selectedCardId.value = '';
}

const submit = async() => {
  try {
    if (selectedCardId.value == '') {
      await DataStore.save(
        Member.copyOf(member.value , updated => {
          updated.paymentMethod = 1;
          updated.currentSquareCardId = '';
        })
      );
    }
    else {
      await DataStore.save(
      Member.copyOf(member.value , updated => {
        updated.paymentMethod = 0;
        updated.currentSquareCardId = selectedCardId.value;
      })
    );
    }
    router.push('mypage');
  }
  catch(e) {
    console.log(e);
  }
}

const updateCards = async() => {
  try {
    if (member.value.squareCustomerId) {
      const keys = await api.generateEncryptedKeys(`${shop.value.squareAppId}$${shop.value.squareLocationId}$${shop.value.squareAccessToken}`);

      cardList.value = await api.getCards(member.value.squareCustomerId, keys);
      console.log(cardList.value);
      selectedCardId.value = member.value.currentSquareCardId!;
    }    
  }
  catch(e) {
    console.log(e);
  }
}

const deleteCard = async(card: CardListDto) => {
  activeDeleteCard.value = null;
  selectedDeleteCard.value = null;

  emit('startLoading');
  await selectPaypay();
  try {
    await DataStore.save(
      Member.copyOf(member.value , updated => {
        updated.paymentMethod = 1;
        updated.currentSquareCardId = '';
      })
    );
    
    const keys = await api.generateEncryptedKeys(`${shop.value.squareAppId}$${shop.value.squareLocationId}$${shop.value.squareAccessToken}`);
    await api.deleteCard(card.cardId, keys);
    setTimeout(async () => {
      await updateCards();
      emit('stopLoading');
    }, 3000);
  }
  catch(e) {
    console.log(e);
    emit('stopLoading');
  }
}

const beginHold = async(cardId: string) => {
  activeDeleteCard.value = null;
  holdHandler.value = setTimeout(async() => {
    activeDeleteCard.value = cardId;
  }, 2000);
}

const endHold = async(card: any) => {
  if (!activeDeleteCard.value) {
    await selectCard(card);
    activeDeleteCard.value = null;
  }
  clearTimeout(holdHandler.value);
}

watch(member, async() => {
  await updateCards();
  emit('stopLoading');
})

onBeforeRouteUpdate(async() => {
  await updateCards();
})

onMounted(() => {
  addEventListener("popstate", () => {
    router.push("/mypage")
  })
});

const brandImgs: any = {
  'VISA': require('@/assets/img/cards/visa.png'),
  'MASTERCARD': require('@/assets/img/cards/master.png'),
  'JCB': require('@/assets/img/cards/jcb.png'),
  'AMERICAN_EXPRESS': require('@/assets/img/cards/amex.png'),
  'DISCOVER_DINERS': require('@/assets/img/cards/diners.png'),
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", {
      ref_key: "cardsEl",
      ref: cardsEl
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardList.value, (card, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row cards",
          key: idx,
          onTouchstart: ($event: any) => (beginHold(card.cardId)),
          onTouchend: ($event: any) => (endHold(card))
        }, [
          _createElementVNode("div", _hoisted_3, [
            (brandImgs[card.brand])
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: brandImgs[card.brand]
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(card.maskedNumber), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(card.month) + "/" + _toDisplayString(card.year), 1),
          (selectedCardId.value == card.cardId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "✓"))
            : _createCommentVNode("", true),
          (activeDeleteCard.value == card.cardId)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "delete",
                onTouchstart: _withModifiers(($event: any) => (selectedDeleteCard.value = card), ["stop"])
              }, "削除", 40, _hoisted_8))
            : _createCommentVNode("", true)
        ], 40, _hoisted_2))
      }), 128))
    ], 512),
    (_unref(shop).squareAppId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "col-12",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('card')))
          }, _hoisted_11)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      (selectedCardId.value == '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, "✓"))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "col-12",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (selectPaypay()))
      }, "PayPay")
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "btn-width relative",
      onClick: submit
    }, "編集"),
    _createVNode(Modal, {
      visible: selectedDeleteCard.value != null,
      onHide: _cache[4] || (_cache[4] = ($event: any) => (selectedDeleteCard.value == null))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, _toDisplayString(selectedDeleteCard.value!.maskedNumber), 1),
            _createElementVNode("div", _hoisted_18, _toDisplayString(selectedDeleteCard.value!.month) + "/" + _toDisplayString(selectedDeleteCard.value!.year), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-white btn-back",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedDeleteCard.value = null))
            }, "キャンセル"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-white btn-back ml-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (deleteCard(selectedDeleteCard.value!)))
            }, "削除")
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})